import type {} from "@lit/react";
import { GridProEditColumn as GridProEditColumnElement, } from "@vaadin/grid-pro/vaadin-grid-pro-edit-column.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridProEditColumnElement, };
export type GridProEditColumnEventMap<T1> = Readonly<{}>;
const events = {} as GridProEditColumnEventMap<any>;
export type GridProEditColumnProps<T1> = WebComponentProps<GridProEditColumnElement<T1>, GridProEditColumnEventMap<T1>>;
export const GridProEditColumn = createComponent({
    elementClass: GridProEditColumnElement, events, react: React, tagName: "vaadin-grid-pro-edit-column"
}) as <T1>(props: GridProEditColumnProps<T1> & React.RefAttributes<GridProEditColumnElement<T1>>) => React.ReactElement | null;
